<template>
<div class="container">

  <PepPoint v-if="selectedPepPointId" isDistance />

<div style="max-height:80vh;overflow-y: scroll;">
  <div class="message-box" v-for="(item, key) in race.data.racePepPointsWoLocation" :key="key" v-bind:class="{active : key === selectedPepPointId}">
  <label>{{item.distanceLocation + 'm ' + item.message}}</label>
  <div>
  <button v-on:click="selectPep(key)">EDIT</button>
  <button v-on:click="removePep(key)">REMOVE</button>
  </div>
  </div>
</div>
<div>
  <button v-on:click="createPep()">Add new pep</button>
  <button v-on:click="previousPage()">Back</button>

  </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.js'
import BottomNav from './BottomNav'
import MobileButton from './MobileButton'
import OwnPepsButton from './OwnPepsButton'
import PepPoint from './PepPoint'
import { store } from '../store/store'
import { mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

import Datepicker from 'vuejs-datepicker'
import VueTimepicker from 'vue2-timepicker'

import firebase from 'firebase'
import { imageStorage } from '../firebase'

import VoiceMessageListener from '../helpers/voiceMessageListener'
import Toasted from 'vue-toasted'

Vue.use(VueMoment, {
  moment
})

Vue.use(Toasted, {position: 'bottom-center', duration: 2000, theme: 'outline'})

const decimalFilter = function(value) {
  return (value / 1000).toFixed(1)
}

const { mapFields } = createHelpers({
  getterType: 'getInfoField',
  mutationType: 'updateInfoField',
})

export default {
  name: 'nopatheditor',
  title: 'Runner - My Routes',
  components: {
    BottomNav,
    MobileButton,
    OwnPepsButton,
    PepPoint,
    Datepicker,
    VueTimepicker
  },
  filters: {
    decimal: decimalFilter
  },
  data() {
    return {
      vml: new VoiceMessageListener(),
      isRaceInfo: false,
      startAmPm: '',
      endAmPm: '',
      liveChosen: false,
      copy: require('../img/copy.svg'),
      copyPressed: false,
      fileSelected: false,
      uploadingFile: false,
      uploadSuccess: false,
      file: ''
    }
  },
  computed: {
    ...mapFields([
      'information'
    ]),
    ...mapGetters({
      race: "race",
      timezone: "timezone",
      selectedPepPointId: "selectedPepPointId",
      currentRaceId: "currentRaceId"
    }),
    friendsLink() {
      return "https://friends.racepeps.com/#/races/" + this.race['.key']
    },
    startTime() {
      var time = moment()
      time.hours(this.information.start.time.HH)
      time.minutes(this.information.start.time.mm)
      return time.format('LT')
    },
    endTime() {
      var time = moment()
      time.hours(this.information.end.time.HH)
      time.minutes(this.information.end.time.mm)
      return time.format('LT')
    }
  },
  mounted() {
    if(this.race) {
    console.log(this.race.data.racePepPointsWoLocation)
  }
  },
  methods: {
    selectPep(id) {
      this.$store.dispatch('selectPepPoint', id)
    },
    removePep(id) {
      this.$store.dispatch('removePepPointWoLocation', id)
    },
    createPep() {
      this.$store.dispatch('addPepPointWoLocation').then((ref) => {
        this.selectPep(ref.key)
      })
    },
    c(event, isStart) {
      console.log(event)
      const { h, mm, a } = event.data
      if(isStart) {
        this.startAmPm = h + ':' + mm + ' ' + a
      } else {
        this.endAmPm = h + ':' + mm + ' ' + a
      }
    },
    liveSender(sender, type) {
      let value = sender
      if(type === 'A') {
        value = "Audio"
      } else if(!sender) {
        value = "Error"
      }
      return value
    },
    previousPage() {
      this.$router.replace('myRaces')
    },
    liveDate(timestamp) {
      return moment(timestamp * 1000).format()
    },
    chooseLive(value) {
      this.liveChosen = value
    },
    copyLink() {
       var el = document.getElementById("link");

       if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
         var editable = el.contentEditable;
         var readOnly = el.readOnly;
         el.contentEditable = true;
         el.readOnly = false;
         var range = document.createRange();
         range.selectNodeContents(el);
         var sel = window.getSelection();
         sel.removeAllRanges();
         sel.addRange(range);
         el.setSelectionRange(0, 999999);
         el.contentEditable = editable;
         el.readOnly = readOnly;
       } else {
         el.select();
       }
       document.execCommand('copy');
       el.blur();
       Vue.toasted.show('Link copied to clipboard');
    },
      onFileChange(e) {
       // console.log(imageStorage)
        console.log(e.target)
      if (e.target.files.length === 0){
        this.fileSelected = false
        this.file = ''
      } else {
        this.file = this.$refs.raceImage.files[0]
        this.fileSelected = true
      }
  },
  }

}
</script>

<style lang="scss">
  @media screen and (max-width: 1140px) {
    .map-container {
      bottom: 200px !important;
    }
  }
</style>

<style lang="scss" scoped>
@import '../styles/styles.scss';

input[type="text"][disabled] {
   color: black;
}

textarea[type="text"][disabled] {
   color: black;
}

.message-box {
  display:flex;
  flex-direction:row;
  justify-content: space-between;
  padding:20px;
  margin: 20px;
  border-color:black;
  border-width:2px;
  border-style: solid;
}


.data-container {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;
    background-color: white;
    padding: 20px;
    height: auto;
    overflow-y: auto;
}

.info-text {
  font-size: 17px;
  color: $cyan-dark;
}

.date-row {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100px;

  label {
    font-size: $font-medium;
    margin-bottom: 10px;
  }

  .date-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 10 0;

    input {
      margin: 0;
    }
  }

}

.row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
}

.description-row {

    textarea {
        width: 100%;
        resize: none;
    }
}

.live-row {
    display: flex;
    flex-direction: row;
    margin-bottom: 12px;
    align-items: center;
    min-height: 30px;

    .live-sender {
      margin-right: 5px;
      font-weight: 700;
    }

    .live-time {
      font-size: 12px;
      opacity: 0.7;
      margin-right: 5px;
    }

    .live-audio-container {
      margin-left: 5px;
    }

    img {
      width: 30px;
      height: 30px;
      display: flex;
      align-self: center;
      cursor: pointer;
    }
}

.info-text {
  font-size: 17px;
  color: $cyan-dark;
}

.active {
  background-color: green;
}

.name-row {
    align-items: center;

    .name {
        margin-right: 5px;
        font-size: $font-semiSemiLarge;
        color: $cyan;
    }
    .length {
        font-size: $font-medium;
    }
}

.header {
    height: 40px;
    font-size: $font-semiLarge;
    display: flex;

    img {
      cursor: pointer;
      height: 40px;
      width:40px;
    }
}

.no-messages {
  display: flex;
  align-self: center;
}

.loader {
  padding: 3px !important;
  margin-top: 0px;
  width: 8px !important;
  height: 8px !important;
}

.friendLink {
  color: $cyan;
  width: 100%;
}

.input-container.date-info {
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  input {
    width: 100px;
    margin-left: 10px;
  }

  textarea {
    width: 100%;
  }
}

.input-container.tracking-info {


  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 30px;
  margin-top: 20px;

  .tracking-on {
    color: $green;
    margin-left: 10px;
    font-weight: bold;
    font-size: 18px;
  }

  .tracking-off {
    color: $red;
    margin-left: 10px;
    font-size: 18px;
    font-weight: bold;
  }

}

.info-dates-container {
  margin: 30px 0px;
}

.switch-container {
  display:flex;
	flex-direction: row;
	width: 100%;
}

.switch {
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 1;
  background-color: $cyan;
	color: white;
	padding-top: 5px;
	padding-bottom: 5px;
  cursor: pointer;
  height: 30px;

	label {
		font-size: $font-semiSemiLarge;
    cursor: pointer;
	}
}

.switch.selected {
	background-color: $green;
}

.image-container {
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 30px;
    height: 30px;
  }
}


@media screen and (min-width: 1140px) {
  .header {
    height: 80px;
    font-size: 24px;
  }

  .switch {
    height: 50px;

    label {
  		font-size: $font-large;
  	}
  }
}
</style>
